export default __webpack_public_path__ + "static/media/Maithili_bf_1.1d7ceb70.mp3";